import PersonalEmailWarning from "../../containers/PersonalEmailWarning";
import { useDispatch, useSelector } from "../../store/store";
import CreatePassword from "./containers/CreatePassword";
import RegisterEmail from "./containers/RegisterEmail";
import UseSignInForm from "./containers/UseSignInForm";
import EmployerInfo from "./containers/EmployerInfo";
import { useSearchParams } from "react-router-dom";
import MemberInfo from "./containers/MemberInfo";
import ReviewInfo from "./containers/ReviewInfo";
import UploadLogo from "./containers/UploadLogo";
import Entrance from "../../layouts/Entrance";
import Approval from "./containers/Approval";
import Verify from "./containers/Verify";
import Legal from "./containers/Legal";
import { useEffect } from "react";
import {
    selectLegalModal,
    selectSignUpStep,
    selectPersonalEmailWarningModal,
} from "../../store/signUp/selectors";
import {
    setLogoImage,
    setUserEmail,
    setEmployerInfo,
    setUserPhoneNumber,
    setSignUpMode,
} from "../../store/signUp/slice";

const steps = {
    registerEmail: {
        title: '',
        component: <RegisterEmail />,
    },
    createPassword: {
        title: '',
        component: <CreatePassword />,
    },
    useSignInForm: {
        title: '',
        component: <UseSignInForm />,
    },
    verifyEmail: {
        title: '',
        component: <Verify />,
    },
    verifyPhoneNumber: {
        title: '',
        component: <Verify />,
    },
    employerInfo: {
        title: '',
        component: <EmployerInfo />,
    },
    memberInfo: {
        title: '',
        component: <MemberInfo />,
    },
    uploadLogo: {
        title: '',
        component: <UploadLogo />,
    },
    reviewInfo: {
        title: 'Review and Confirm',
        component: <ReviewInfo />,
    },
    approval: {
        title: '',
        component: <Approval />
    }
};

function SignUp() {
    const [params, setParams] = useSearchParams();
    const memberToken = params.get('token');
    const dispatch = useDispatch();
    const step = useSelector(selectSignUpStep);
    const legalModal = useSelector(selectLegalModal);
    const personalEmailWarningModal = useSelector(selectPersonalEmailWarningModal);

    const fullScreenMode =
        step === 'employerInfo' ||
        step === 'reviewInfo' ||
        step === 'approval';

    useEffect(() => {
        if (memberToken) {
            dispatch(setSignUpMode('Member'));
        }

        return () => {
            dispatch(setUserEmail(''));
            dispatch(setUserPhoneNumber(''));
            dispatch(setLogoImage(null));
            dispatch(setEmployerInfo(null));
        }
    }, []);

    return (
        <Entrance fullScreenMode={fullScreenMode}>
            {/* {steps[step].title && (<span className={styles.title}>{steps[step].title}</span>)} */}
            {steps[step].component}
            {legalModal && <Legal />}
            {personalEmailWarningModal && <PersonalEmailWarning />}
        </Entrance>
    );
};

export default SignUp;
